import { generate_random_color } from "#shared/utility_functions/color_functions";
import { checkIfValidDate } from "#shared/stringConditionals";
import { blockerFunction } from "@src/utility_functions/utility_functions/dom_functions";
import { validateFileInterval } from "@src/utility_functions/inputValidation/validateFileInterval";
import { addMinutesToDate } from "@src/utility_functions/utility_functions/date_functions";

// Netflix exports carry only a watch date — every viewing renders as a
// fixed-length event until real durations exist.
const DEFAULT_VIEWING_DURATION_MINUTES = 30;

export const parseCSVDataIntoIntervalsNetflix = async (
  data,
  setParsedItemCount,
  setFileError,
) => {
  let returnValue = {
    errors: 0,
    intervals: [],
  };

  for (let index = 0; index < data.length; index++) {
    setParsedItemCount((prev) => {
      return prev + 1;
    });
    const item = data[index];
    const startDate = new Date(item.Date);
    const dateValid = checkIfValidDate(startDate);
    if (!dateValid) {
      console.warn("Invalid date format", item);
      continue;
    }
    const startDateFormatted = new Date(item.Date).toISOString();
    const endDateFormatted = addMinutesToDate(
      startDateFormatted,
      DEFAULT_VIEWING_DURATION_MINUTES,
    ).toISOString();
    //make same labels the same colors
    //make same days quantize to discreet times
    //might have to keep a running count of shows watched within a certain time period and quantize them out.

    const newInterval = {
      label: item.Title,
      description: item.Title,
      startTime: startDateFormatted,
      endTime: endDateFormatted,
      primaryColor: item.primaryColor || generate_random_color("color"),
      secondaryColor: item.secondaryColor || generate_random_color("shade"),
    };
    const intervalValid = validateFileInterval(
      newInterval,
      setFileError,
      index,
    );
    await blockerFunction(1);
    if (intervalValid) {
      returnValue.intervals.push(newInterval);
    } else {
      returnValue.errors += 1;
    }
  }
  return returnValue;
};
